import { Button, Column, Row } from '../../../components'
import { useContext, useEffect, useState } from 'react';
import { RolePrivilegeSetupLabels } from '../../../shared/util/label'
import RolesSideBar from '../RolesSideBar/RolesSideBar';
import { FallbackComponent } from '../../../shared/components/FallbackComponent'
import { ErrorBoundary } from 'react-error-boundary'
import ScreenPrivilege from '../ScreenPrivilegeSetup/ScreenPrivilege';
import './RolePrivilegeMain.scss';
import { useHistory, useParams } from 'react-router-dom';
import AppContext from '../../../shared/components/AppContext';
import * as constant from '../../../shared/util/constant'
import { useConfirmationModalContext } from '../../../shared/components/ModalConfirmationContext';
import { Card, Container, Navbar } from 'react-bootstrap';
import ScreenPrivilegeService from '../ScreenPrivilegeSetup/ScreenPrivilegeService';
import { generateSectionedCsv } from '../../utils/CSVExport';
import RolePrivilegeSetupAPI from '../../Services/RolePrivilegeSetupAPI';
import { AbilityContext } from '../../../shared/abilities/AbilityContext';

const RolePrivilegeMain = () => {

    const { roleId } = useParams<{roleId : string | undefined}>();

    const [selectedRoleId, setSelectedRoleId] = useState<string>(null);

    const [showRoleDetailsOnLoad, setShowRoleDetailsOnLoad] = useState<boolean>(false);

    const modalContext = useConfirmationModalContext();

    const privielgeContext = useContext(AppContext);

    const ability = useContext(AbilityContext);
    const canCreate = ability.can('create', constant.AdminSubject, constant.AdminScreenPrivileges.Role_Privilege_Setup);

    const [reloadSidebar, setReloadSidebar] = useState(false)

    const history = useHistory();

    const screenPrivilegeService = new ScreenPrivilegeService();
    const rolePrivilegeService = new RolePrivilegeSetupAPI();

    const handleNewRoleClick = async () => {
        if (!privielgeContext.formSavedStatus) {
            const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
            if (result) {
                setSelectedRoleId(null);
                 setShowRoleDetailsOnLoad(true);
                 privielgeContext.formSavedStatus = true
                 history.push(`/admin/roleprivilege`);
            }
        }
        else {
            setSelectedRoleId(null);
            setShowRoleDetailsOnLoad(true);
            history.push(`/admin/roleprivilege`);
        }
    };

    const handleCancelClick = async () => {
        setSelectedRoleId(null);
        setShowRoleDetailsOnLoad(false);
        history.push(`/admin/roleprivilege`);
    };

    const handleSave = async (newRoleId) => {
        history.push(`/admin/roleprivilege/${newRoleId}`);
        setReloadSidebar(!reloadSidebar)

    };

    const handleExportClick = async () =>{
        let featureElements = [];

        let users = await rolePrivilegeService.getUserListByRole(roleId);
        let screenPrivilage = await screenPrivilegeService.getFeatures();
        let roleDetails = await screenPrivilegeService.getRoleDetails(roleId);

        // collect unique featureIds that require fetching elements
        const featureIds = new Set<string>();
        roleDetails.featurePrivielges.forEach(fp => {
            fp.elementPrivilege.forEach(ep => {
                if (ep.elementId != null) {
                    featureIds.add(ep.featureId);
                }
            });
        });

        // fetch all feature elements in parallel and flatten results
        const fetchedArrays = await Promise.all(
            Array.from(featureIds).map(fid => screenPrivilegeService.getFeatureElements(fid))
        );
        
        fetchedArrays.forEach(arr => featureElements.push(...(arr || [])));

        // now we can safely resolve names (featureElements is populated)
        roleDetails.featurePrivielges.forEach(fp => {
            fp.elementPrivilege.forEach(y => {
                let name;
                if (y.elementId == null) {
                    name = screenPrivilage.find(r => r.value == y.featureId);
                } else {
                    name = featureElements.find(r => r.value == y.elementId);
                }
                y["name"] = name.label;
            });
        });
        
        generateSectionedCsv(roleDetails.roleDetails.roleName, users, roleDetails.featurePrivielges);
    }
    
   

    useEffect(() => {
        if (roleId) 
        {
            setSelectedRoleId(roleId);
            setShowRoleDetailsOnLoad(true);            
        }
    }, [roleId]);

    return (
        <>
            <Container fluid className='px-4'>
                <Row className="role-privilege-main">
                    <Column lg={12} md={12}>
                        <ErrorBoundary FallbackComponent={FallbackComponent}>
                        <Row>
                                    <Column lg={12}>
                                        <Navbar className="bg-transparent exportButtonWrapper">
                                            <Navbar.Brand>Role Privileges</Navbar.Brand>

                                            <div>
                                            <Button className='ms-auto' color='primary' outlined={true} onClick={handleNewRoleClick} disabled={!canCreate}>{RolePrivilegeSetupLabels.NEW_ROLE} </Button>

                                            <Button className='ms-auto exportBtn' color='primary' outlined={true} onClick={handleExportClick}>Export to CSV</Button>
                                            </div>
                                        </Navbar>
                                    </Column>
                                </Row>
                            {/* <Card> */}
                                <Container fluid>
                               
                                <Row>
                                    <Column lg={12} className='role-details'>
                                        <Row>
                                            <Column lg={3} className='roles-sidebar ps-0'>
                                                <ErrorBoundary FallbackComponent={FallbackComponent}>
                                                    <div className={`active card shadow-sm`}>
                                                        <RolesSideBar reload={reloadSidebar} />
                                                    </div>
                                                </ErrorBoundary>
                                            </Column>
                                            
                                            {showRoleDetailsOnLoad &&
                                                <Column lg={9} className={'screen-privilege'}>
                                                    {/* <Card> */}
                                                    <ErrorBoundary FallbackComponent={FallbackComponent}>
                                                        <div className='p-0'>
                                                            <ScreenPrivilege roleId={selectedRoleId} onCancel={handleCancelClick} onSave={handleSave}></ScreenPrivilege>
                                                        </div>
                                                    </ErrorBoundary>
                                            {/* </Card> */}

                                                </Column>
                                            }
                                            
                                        </Row>
                                    </Column>
                                </Row>
                                </Container>
                               
                            {/* </Card> */}

                        </ErrorBoundary>
                    </Column>
                </Row>
            </Container>

        </>
    )
}

export default RolePrivilegeMain;